export const PasswordMinLength = 8;
export const PasswordMaxLength = 70;
export const PasswordValidityChecks = [/[a-z]/, /[A-Z]/, /\d/, /[^A-z\d]/];
